import React, { useEffect, useRef } from "react";
import { Linkedin, ArrowUpRight } from "lucide-react";
import { FOUNDER } from "../mock";
import karen from "../assets/karen.jpg";

export default function Founder() {
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in-view")),
      { threshold: 0.15 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="sobre" ref={ref} className="relative py-24 md:py-36" style={{ background: "#001d3f" }}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left: portrait + years badge */}
          <div className="lg:col-span-5">
            <div className="reveal relative rounded-3xl overflow-hidden aspect-[4/5]">
              <img src={karen} alt={FOUNDER.name} className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,29,63,0) 55%, rgba(0,16,31,0.55) 100%)" }} />
              <div className="absolute bottom-5 left-5 rounded-2xl px-5 py-4" style={{ background: "rgba(0,16,31,0.7)", backdropFilter: "blur(6px)", border: "1px solid rgba(177,205,255,0.2)" }}>
                <div className="font-display font-semibold text-[40px] leading-none" style={{ color: "#e55b36" }}>{FOUNDER.years}</div>
                <div className="text-[13px] mt-1" style={{ color: "#b1cdff" }}>{FOUNDER.yearsLabel}</div>
              </div>
            </div>
          </div>

          {/* Right: bio */}
          <div className="lg:col-span-7">
            <p className="reveal uppercase tracking-[0.35em] text-[12px] mb-4" style={{ color: "#e55b36" }}>{FOUNDER.eyebrow}</p>
            <h2 className="reveal font-display font-semibold text-white text-[44px] md:text-[68px] leading-none">{FOUNDER.name}</h2>
            <p className="reveal mt-5 font-display text-[20px] md:text-[24px]" style={{ color: "#b1cdff" }}>{FOUNDER.role}</p>
            <p className="reveal mt-6 text-[16px] md:text-[18px] leading-relaxed text-white/90 max-w-2xl">{FOUNDER.bio}</p>

            <a href={FOUNDER.linkedin} target="_blank" rel="noopener noreferrer" className="reveal inline-flex items-center gap-2 mt-7 rounded-full px-6 py-3 font-semibold text-[15px] transition-all hover:-translate-y-0.5" style={{ border: "1.5px solid rgba(177,205,255,0.4)", color: "#fff" }}>
              <Linkedin size={18} /> Ver LinkedIn <ArrowUpRight size={16} />
            </a>

            <div className="reveal mt-12">
              <p className="text-[13px] uppercase tracking-[0.3em] mb-5" style={{ color: "#8fb3f0" }}>Trabajé con</p>
              <div className="flex flex-wrap gap-3">
                {FOUNDER.worked.map((c) => (
                  <span key={c} className="rounded-full px-5 py-2.5 font-display font-medium text-[16px] text-white" style={{ background: "#00101f", border: "1px solid rgba(177,205,255,0.15)" }}>
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
